import React, { useContext, useEffect } from "react";
import { templateActionEnum } from "../../Config/Constants";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import ToastComponent from "../Shared/ToastComponent";
import TopBtnGroup from "./NavBar/NavBar";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../Util/Constants";
import { goToDashboardAfterDownload } from "../../Util/DownloadHelper";
import { appDomain, getLogoImagePath } from "../../Util/general-config";

type Props = {};

const Header = (props: Props) => {
  const { state, dispatch } = useContext(TemplateDataContext);
  const { show, message } = state.error;
  const navigate = useNavigate();
  const location = useLocation();

  const HomeNavigate = () => {
    if (location.pathname.includes("plans") || location.pathname.includes("confirmation")) {
      goToDashboardAfterDownload(true);
    } else if (!location.pathname.includes("checkout")) {
      if (process.env.NODE_ENV == "development") {
        navigate(ROUTE_CONSTANT.LANDINGPAGE);
      } else {
        window.location.href = appDomain();
      }
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* Toast Message for Errors */}
      <ToastComponent
        show={show || false}
        message={message || ""}
        closeHandler={() =>
          dispatch({
            type: templateActionEnum.SET_ERROR,
            payload: { show: false },
          })
        }
      />
      {/* Header */}
      <header className="header margin-adjust">
        <nav className="navbar navbar-expand-lg navbar-light py-md-4 border-bottom">
          <div className="container">
            <div onClick={HomeNavigate} className="navbar-brand">
              <img
                className="legalsimpli-logo"
                src={getLogoImagePath()}
                alt="PDFsimpli"
                // /app/template/static/images/legalsimpli-logo.svg
                draggable="false"
              />
              {/* <span className="sr-only">LegalSimpli</span> */}
            </div>
            <div id="navbarNavAltMarkup">
              <TopBtnGroup />
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
